module.exports = __webpack_public_path__ + "static/media/mysirg_logo.e91cdbd7.png";